module.exports = __webpack_public_path__ + "yeni dolap.jpeg?746ac15946500b7c7514c97635af99b1";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni dolap.jpeg
// module id = 382
// module chunks = 0